import { render } from "./FridgeDetailsConfirmSettingsDialog.vue?vue&type=template&id=d2ac2502&scoped=true&ts=true"
import script from "./FridgeDetailsConfirmSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsConfirmSettingsDialog.vue?vue&type=script&lang=ts"

import "./FridgeDetailsConfirmSettingsDialog.vue?vue&type=style&index=0&id=d2ac2502&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2ac2502"]])

export default __exports__